import { defineStore } from 'pinia';

export const useSidebarStore = defineStore('sidebar', {
	state: () => {
		return {
			collapse: false,// for PC sidebar
      showMobileSideBar: false, // for mobile mode 
      collapseMobile: true // for mobile sidebar
		};
	},
	getters: {},
	actions: {
		handleCollapse () {
      if(this.showMobileSideBar){
        this.collapseMobile = !this.collapseMobile
        //console.log('mmmmmmmmmb')
      }else{
        // this.collapse = true;
        this.collapse = !this.collapse;
        //console.log('wwwwwwwwweb')

      }
      //console.log(this.collapse,'this.collapse')
      //console.log(this.showMobileSideBar,'this.showMobileSideBar')
      //console.log(this.collapseMobile,'this.collapseMobile')
			
		},
    handleMobile () {
			this.showMobileSideBar = !this.showMobileSideBar;
		}
	}
});
